import { PROJECT_BRANDS } from '@/modules/brand/domain/brand';

export default function ({ store, req }, inject) {
  const getBrandFromHost = (host) => {
    if (host.includes('reverse.health')) {
      return PROJECT_BRANDS.reverse;
    }
    if (host.includes('musclecharge.app')) {
      return PROJECT_BRANDS.muscleCharge;
    }
    return PROJECT_BRANDS.reverse;
  };

  const host = process.server ? req.headers.host : window.location.host;
  const brand = getBrandFromHost(host);

  store.commit('brand/SET_BRAND', brand);

  inject('getBrand', () => store.getters['brand/getBrand']);
}
